import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 3 класс",
        subject: "Работа над многообразием значений имён прилагательных как средство развития речи",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Работа над многообразием значений имён прилагательных как средство развития речи",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Романова Владислава Юрьевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории начального общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Педагоги, конечно, знают, что проблемы, связанные с речью современного младшего школьника, решаются непросто. </p>
                                </div>
                                 <div style='padding: 2.4rem;'>Так, неодоценивание необходимости расширения словарного запаса приводит к трудностям понимания роли имён прилагательных для точной и выразительной речи. А отсутствие умения воспринимать текст с элементами описания даёт трудности уместного использования имён прилагательных при создании текстов. </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Эти и другие проблемы (невыразительность, ошибочность в использовании языковых средств и т.п.) свидетельствуют о том, что необходимо активизировать деятельность обучающихся, направленную на знакомство, использование, осознание множества значений имён прилагательных в русском языке.  </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Цель данного методического кейса — привлечь внимание к решению данных проблем; показать, что основной причиной возникающих трудностей является недостаточное внимание учителя к эффективным способам освоения темы – сравнению, сопоставлению языковых единиц на основе простого опыта и т.п.</div>
                                <div style='padding: 2.4rem; padding-top: 0; padding-bottom: 0'>
                                    <p>Материалы кейса помогут педагогам научить детей:</p>
                                    <ul>
                                    <li>воспринимать высказывания и тексты с элементами описания;</li>
                                    <li>характеризовать объекты; </li>
                                    <li>использовать эпитеты; </li>
                                    <li>учитывать сочетаемость слов. </li>
                                    </ul>
                                    </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Анализируемые задания будут способствовать развитию у учеников языковой интуиции, воображения, пробуждению эстетического интереса.</div>
                                <div style='padding: 2.4rem; padding-top: 0'>В условиях, когда катастрофически падает культура речи, культура письма, культура общения, воспитание внимательного и осознанного отношения к родному языку уже в начальной школе не вызывает сомнения. </div>
`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist1/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4"
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 3",
            imagePath: "",
            id: "3",
            videoUrl: "./video/video3.mp4"
        },
        {
            order: 7,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Брушлинский А.В. Субъект: мышление, учение, воображение. – Воронеж, 1996",
                "Волина В.В. Весёлая грамматика. – Москва: Знание, 1995",
                "Вольф Е.М. Грамматика и семантика прилагательного. – Москва: Изд. группа «Дрофа», 2003",
                "Словарь эпитетов русского языка / К.С. Горбачевич, Е.П. Хабло. – Ленинград: Наука, Ленинградское отделение, 1979",
                "Современный русский язык. Морфология / Под ред. В.В.Виноградова. – Москва: Айрис-пресс, 2008"
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дополнительные задания, которые помогают реализовать потенциал анализа состава слов в обогащении словарного запаса"
                }
            ]
        }
    ],
};
